import React from 'react'
import AboutCard from './AboutCard'

export default function AboutContainer() {
    return (
        <div className='about-container'>
            <AboutCard />
        </div>
    )
}
